/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SnapshotUpdate
 */
export interface SnapshotUpdate {
    /**
     * 
     * @type {number}
     * @memberof SnapshotUpdate
     */
    workspace: number;
    /**
     * 
     * @type {string}
     * @memberof SnapshotUpdate
     */
    name?: string;
}

export function SnapshotUpdateFromJSON(json: any): SnapshotUpdate {
    return SnapshotUpdateFromJSONTyped(json, false);
}

export function SnapshotUpdateFromJSONTyped(json: any, ignoreDiscriminator: boolean): SnapshotUpdate {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'workspace': json['workspace'],
        'name': !exists(json, 'name') ? undefined : json['name'],
    };
}

export function SnapshotUpdateToJSON(value?: SnapshotUpdate | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'workspace': value.workspace,
        'name': value.name,
    };
}


